export const PARAM = "hp_param";
export const PAGE_CONFIG = "hp_page_config";
export const HP_COOKIE = "hp_cookie";
export const PLATFORM_COOKIE = "platform_cookie";
export const HP_SIGNUP_BUTTON = "hp_signup_button";
//reasons
export const SET_CLUSTER_FROM_PAGE_CONFIG_REASON = "set_cluster_from_page_config";
export const SET_CLUSTER_FROM_SIGNUP_BUTTON_REASON = "set_cluster_from_signup_button";
